import adminApi from './api';
import authService from './authService';
const token = authService.getToken();

export const getCategories = async () => {
  try {
    // Note: The endpoint might be different - adjust based on your actual API
    const response = await adminApi.get('/categories/');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createJob = async (jobData) => {
  try {
    const response = await adminApi.post('/jobs/create', jobData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getJobs = async (params = {}) => {
  try {
    const response = await adminApi.get('/jobs', { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getJobById = async (id) => {
  try {
    const response = await adminApi.get(`/jobs/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateJob = async (id, jobData) => {
  try {
    const response = await adminApi.put(`/jobs/${id}`, jobData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteJob = async (id) => {
  try {
    const response = await adminApi.delete(`/jobs/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateJobStatus = async (id, status) => {
  try {
    const response = await adminApi.patch(`/jobs/${id}/status`, { status }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
